'use client';

import { Flex, List, ListItem, Typography } from '@coolblue-development/freddy';

type ArticleContentErrorsProps = {
  errors: string[] | null | undefined;
};

export const ArticleContentErrors = ({ errors }: ArticleContentErrorsProps) => {
  const hasErrors = errors && errors.length > 0;

  return (
    <Flex direction='column'>
      <Typography variant='h3' mb={hasErrors ? 300 : 200}>
        GraphQL Response Errors
      </Typography>
      {hasErrors && (
        <List component='ul'>
          {errors.map((err, index) => (
            <ListItem key={index}>{err}</ListItem>
          ))}
        </List>
      )}
    </Flex>
  );
};
